import { PartitionPattern } from "#packages/ecma402-abstract/PartitionPattern.js";
import "#packages/ecma402-abstract/types/date-time.js";
import { HandleDateTimeValue } from "#packages/ecma402-abstract/DateTimeFormat/HandleDateTimeValue.js";
import { FormatDateTimePattern } from "#packages/ecma402-abstract/DateTimeFormat/FormatDateTimePattern.js";
import "#packages/ecma402-abstract/DateTimeFormat/ToLocalTime.js";
/**
* https://tc39.es/ecma402/#sec-partitiondatetimepattern
* @param dtf
* @param x
*/
export function PartitionDateTimePattern(dtf, x, implDetails) {
	const record = HandleDateTimeValue(implDetails.getInternalSlots(dtf), x);
	const internalSlots = record.format;
	const { pattern } = internalSlots;
	return FormatDateTimePattern(dtf, PartitionPattern(pattern), record.epochNanoseconds, record.isPlain, {
		...implDetails,
		getInternalSlots: () => internalSlots
	});
}
